import * as React from "react"
import { Link } from "react-router-dom"

const urlIsInternal = (url: string): boolean =>
	url.indexOf("/") === 0 && url.indexOf("//") === -1 && url.indexOf("#") === -1

interface DynamicLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
	url: string
	target?: string
	display?: string
	onClick?: () => void
}

const DynamicLink: React.FC<DynamicLinkProps> = ({
	url,
	children,
	onClick,
	display,
	...rest
}) => {
	return urlIsInternal(url) ? (
		<Link
			to={url ?? "#"}
			{...rest}
			style={{ width: "100%" }}
			onClick={onClick ?? null}
		>
			{children}
		</Link>
	) : (
		<a href={url} {...rest} style={{ width: "100%", display: display }} onClick={onClick ?? null}>
			{children}
		</a>
	)
}

export { DynamicLink }
